export const schematicMappingMock = {
  mapping: {
    code: [
      {
        id: 'G01',
        vdd: '530',
        feature: 'CentralHeatingOperationState',
      },
      {
        id: 'G01',
        vdd: '531',
        feature: 'DomesticHotWaterOperationState',
      },
      {
        id: 'G01',
        vdd: '1799',
        feature: 'x',
      },
      {
        id: 'G03',
        vdd: '381',
        feature: 'x',
      },
      {
        id: 'G03',
        vdd: '457',
        feature: 'x',
      },
      {
        id: 'G04',
        vdd: '392',
        feature: 'x',
      },
      {
        id: 'G13',
        vdd: '1643',
        feature: 'x',
      },
      {
        id: 'G05',
        vdd: '396',
        feature: 'x',
      },
      {
        id: 'G05',
        vdd: '271',
        feature: 'x',
      },
      {
        id: 'G06',
        vdd: '386',
        feature: 'x',
      },
      {
        id: 'G06',
        vdd: '387',
        feature: 'x',
      },
      {
        id: 'G11',
        vdd: '2457',
        feature: 'x',
      },
      {
        id: 'G11',
        vdd: '274',
        feature: 'x',
      },
      {
        id: 'G12',
        vdd: '360',
        feature: 'x',
      },
      {
        id: 'G27',
        vdd: '1043',
        feature: 'x',
      },
      {
        id: 'G28',
        vdd: '318',
        feature: 'x',
      },
      {
        id: 'G28',
        vdd: '1721',
        feature: 'x',
      },
      {
        id: 'H01',
        vdd: '880',
        feature: 'x',
      },
      {
        id: 'H01',
        vdd: '1192',
        feature: 'x',
      },
      {
        id: 'H03',
        vdd: '401',
        feature: 'x',
      },
      {
        id: 'H09',
        vdd: '282',
        feature: 'x',
      },
      {
        id: 'H20',
        vdd: '881',
        feature: 'x',
      },
      {
        id: 'H20',
        vdd: '1193',
        feature: 'x',
      },
      {
        id: 'H22',
        vdd: '1644',
        feature: 'x',
      },
      {
        id: 'H22',
        vdd: '286',
        feature: 'x',
      },
      {
        id: 'H23',
        vdd: '402',
        feature: 'x',
      },
      {
        id: 'H24',
        vdd: '476',
        feature: 'x',
      },
      {
        id: 'H30',
        vdd: '882',
        feature: 'x',
      },
      {
        id: 'H30',
        vdd: '1194',
        feature: 'x',
      },
      {
        id: 'H32',
        vdd: '1645',
        feature: 'x',
      },
      {
        id: 'H32',
        vdd: '288',
        feature: 'x',
      },
      {
        id: 'H33',
        vdd: '403',
        feature: 'x',
      },
      {
        id: 'H34',
        vdd: '477',
        feature: 'x',
      },
      {
        id: 'H40',
        vdd: '883',
        feature: 'x',
      },
      {
        id: 'H40',
        vdd: '1195',
        feature: 'x',
      },
      {
        id: 'H42',
        vdd: '1646',
        feature: 'x',
      },
      {
        id: 'H42',
        vdd: '290',
        feature: 'x',
      },
      {
        id: 'H43',
        vdd: '404',
        feature: 'x',
      },
      {
        id: 'H44',
        vdd: '478',
        feature: 'x',
      },
      {
        id: 'S05',
        vdd: '417',
        feature: 'x',
      },
      {
        id: 'S05',
        vdd: '1172',
        feature: 'x',
      },
      {
        id: 'S53',
        vdd: '273',
        feature: 'x',
      },
      {
        id: 'S54',
        vdd: '275',
        feature: 'x',
      },
      {
        id: 'S55',
        vdd: '1608',
        feature: 'x',
      },
      {
        id: 'S56',
        vdd: '1609',
        feature: 'x',
      },
      {
        id: 'S56',
        vdd: '1610',
        feature: 'x',
      },
      {
        id: 'S89',
        vdd: '1662',
        feature: 'x',
      },
      {
        id: 'T40',
        vdd: '491',
        feature: 'x',
      },
      {
        id: 'T40',
        vdd: '497',
        feature: 'x',
      },
      {
        id: 'T44',
        vdd: '1541',
        feature: 'x',
      },
      {
        id: 'T44',
        vdd: '1661',
        feature: 'x',
      },
      {
        id: 'T44',
        vdd: '873',
        feature: 'x',
      },
      {
        id: 'G01',
        vdd: '530',
        feature: 'x',
      },
      {
        id: 'G01',
        vdd: '531',
        feature: 'x',
      },
      {
        id: 'G01',
        vdd: '1799',
        feature: 'x',
      },
      {
        id: 'G03',
        vdd: '381',
        feature: 'x',
      },
      {
        id: 'G03',
        vdd: '457',
        feature: 'x',
      },
      {
        id: 'G04',
        vdd: '392',
        feature: 'x',
      },
      {
        id: 'G13',
        vdd: '1643',
        feature: 'x',
      },
      {
        id: 'G05',
        vdd: '396',
        feature: 'x',
      },
      {
        id: 'G05',
        vdd: '271',
        feature: 'x',
      },
      {
        id: 'G06',
        vdd: '386',
        feature: 'x',
      },
      {
        id: 'G06',
        vdd: '387',
        feature: 'x',
      },
      {
        id: 'G11',
        vdd: '2457',
        feature: 'x',
      },
      {
        id: 'G11',
        vdd: '274',
        feature: 'x',
      },
      {
        id: 'G12',
        vdd: '360',
        feature: 'x',
      },
      {
        id: 'G27',
        vdd: '1043',
        feature: 'x',
      },
      {
        id: 'G28',
        vdd: '318',
        feature: 'x',
      },
      {
        id: 'G28',
        vdd: '1721',
        feature: 'x',
      },
      {
        id: 'H01',
        vdd: '880',
        feature: 'x',
      },
      {
        id: 'H01',
        vdd: '1192',
        feature: 'x',
      },
      {
        id: 'H03',
        vdd: '401',
        feature: 'x',
      },
      {
        id: 'H09',
        vdd: '282',
        feature: 'x',
      },
      {
        id: 'H20',
        vdd: '881',
        feature: 'x',
      },
      {
        id: 'H20',
        vdd: '1193',
        feature: 'x',
      },
      {
        id: 'H22',
        vdd: '1644',
        feature: 'x',
      },
      {
        id: 'H22',
        vdd: '286',
        feature: 'x',
      },
      {
        id: 'H23',
        vdd: '402',
        feature: 'x',
      },
      {
        id: 'H24',
        vdd: '476',
        feature: 'x',
      },
      {
        id: 'H30',
        vdd: '882',
        feature: 'x',
      },
      {
        id: 'H30',
        vdd: '1194',
        feature: 'x',
      },
      {
        id: 'H32',
        vdd: '1645',
        feature: 'x',
      },
      {
        id: 'H32',
        vdd: '288',
        feature: 'x',
      },
      {
        id: 'H33',
        vdd: '403',
        feature: 'x',
      },
      {
        id: 'H34',
        vdd: '477',
        feature: 'x',
      },
      {
        id: 'H40',
        vdd: '883',
        feature: 'x',
      },
      {
        id: 'H40',
        vdd: '1195',
        feature: 'x',
      },
      {
        id: 'H42',
        vdd: '1646',
        feature: 'x',
      },
      {
        id: 'H42',
        vdd: '290',
        feature: 'x',
      },
      {
        id: 'H43',
        vdd: '404',
        feature: 'x',
      },
      {
        id: 'H44',
        vdd: '478',
        feature: 'x',
      },
      {
        id: 'S05',
        vdd: '417',
        feature: 'x',
      },
      {
        id: 'S05',
        vdd: '1172',
        feature: 'x',
      },
      {
        id: 'S53',
        vdd: '273',
        feature: 'x',
      },
      {
        id: 'S54',
        vdd: '275',
        feature: 'x',
      },
      {
        id: 'S55',
        vdd: '1608',
        feature: 'x',
      },
      {
        id: 'S56',
        vdd: '1609',
        feature: 'x',
      },
      {
        id: 'S56',
        vdd: '1610',
        feature: 'x',
      },
      {
        id: 'S89',
        vdd: '1662',
        feature: 'x',
      },
      {
        id: 'T40',
        vdd: '491',
        feature: 'x',
      },
      {
        id: 'T40',
        vdd: '497',
        feature: 'x',
      },
      {
        id: 'T44',
        vdd: '1541',
        feature: 'x',
      },
      {
        id: 'T44',
        vdd: '1661',
        feature: 'x',
      },
      {
        id: 'T44',
        vdd: '873',
        feature: 'x',
      },
      {
        id: 'G01',
        vdd: '530',
        feature: 'x',
      },
      {
        id: 'G01',
        vdd: '531',
        feature: 'x',
      },
      {
        id: 'G01',
        vdd: '1799',
        feature: 'x',
      },
      {
        id: 'G03',
        vdd: '381',
        feature: 'x',
      },
      {
        id: 'G03',
        vdd: '457',
        feature: 'x',
      },
      {
        id: 'G04',
        vdd: '392',
        feature: 'x',
      },
      {
        id: 'G13',
        vdd: '1643',
        feature: 'x',
      },
      {
        id: 'G05',
        vdd: '396',
        feature: 'x',
      },
      {
        id: 'G05',
        vdd: '271',
        feature: 'x',
      },
      {
        id: 'G06',
        vdd: '386',
        feature: 'x',
      },
      {
        id: 'G06',
        vdd: '387',
        feature: 'x',
      },
      {
        id: 'G11',
        vdd: '2457',
        feature: 'x',
      },
      {
        id: 'G11',
        vdd: '274',
        feature: 'x',
      },
      {
        id: 'G12',
        vdd: '360',
        feature: 'x',
      },
      {
        id: 'G27',
        vdd: '1043',
        feature: 'x',
      },
      {
        id: 'G28',
        vdd: '318',
        feature: 'x',
      },
      {
        id: 'G28',
        vdd: '1721',
        feature: 'x',
      },
      {
        id: 'H01',
        vdd: '880',
        feature: 'x',
      },
      {
        id: 'H01',
        vdd: '1192',
        feature: 'x',
      },
      {
        id: 'H03',
        vdd: '401',
        feature: 'x',
      },
      {
        id: 'H09',
        vdd: '282',
        feature: 'x',
      },
      {
        id: 'H20',
        vdd: '881',
        feature: 'x',
      },
      {
        id: 'H20',
        vdd: '1193',
        feature: 'x',
      },
      {
        id: 'H22',
        vdd: '1644',
        feature: 'x',
      },
      {
        id: 'H22',
        vdd: '286',
        feature: 'x',
      },
      {
        id: 'H23',
        vdd: '402',
        feature: 'x',
      },
      {
        id: 'H24',
        vdd: '476',
        feature: 'x',
      },
      {
        id: 'H30',
        vdd: '882',
        feature: 'x',
      },
      {
        id: 'H30',
        vdd: '1194',
        feature: 'x',
      },
      {
        id: 'H32',
        vdd: '1645',
        feature: 'x',
      },
      {
        id: 'H32',
        vdd: '288',
        feature: 'x',
      },
      {
        id: 'H33',
        vdd: '403',
        feature: 'x',
      },
      {
        id: 'H34',
        vdd: '477',
        feature: 'x',
      },
      {
        id: 'H40',
        vdd: '883',
        feature: 'x',
      },
      {
        id: 'H40',
        vdd: '1195',
        feature: 'x',
      },
      {
        id: 'H42',
        vdd: '1646',
        feature: 'x',
      },
      {
        id: 'H42',
        vdd: '290',
        feature: 'x',
      },
      {
        id: 'H43',
        vdd: '404',
        feature: 'x',
      },
      {
        id: 'H44',
        vdd: '478',
        feature: 'x',
      },
      {
        id: 'S05',
        vdd: '417',
        feature: 'x',
      },
      {
        id: 'S05',
        vdd: '1172',
        feature: 'x',
      },
      {
        id: 'S53',
        vdd: '273',
        feature: 'x',
      },
      {
        id: 'S54',
        vdd: '275',
        feature: 'x',
      },
      {
        id: 'S55',
        vdd: '1608',
        feature: 'x',
      },
      {
        id: 'S56',
        vdd: '1609',
        feature: 'x',
      },
      {
        id: 'S56',
        vdd: '1610',
        feature: 'x',
      },
      {
        id: 'S89',
        vdd: '1662',
        feature: 'x',
      },
      {
        id: 'T40',
        vdd: '491',
        feature: 'x',
      },
      {
        id: 'T40',
        vdd: '497',
        feature: 'x',
      },
      {
        id: 'T44',
        vdd: '1541',
        feature: 'x',
      },
      {
        id: 'T44',
        vdd: '1661',
        feature: 'x',
      },
      {
        id: 'T44',
        vdd: '873',
        feature: 'x',
      },
    ],
  },
};
export const schematicMock = `<svg viewBox="0.00 0.00 175.00 138.20" width="175.00mm" height="138.20mm" preserveAspectRatio="xMidYMid slice" zoomAndPan="magnify" contentscripttype="text/ecmascript" contentstyletype="text/css" version="1.0" xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" fill-rule="evenodd" xml:space="preserve">
<defs></defs>
<g stroke-width="0.05" stroke="none" fill="rgb(153,255,153)">
 <path stroke="none" fill="rgb(153,255,153)" d="M25.0709,118.973 23.1745,118.973 22.99,118.992 22.8126,119.045 22.649,119.133 22.5057,119.25 22.3881,119.394 22.3007,119.557 22.2469,119.735 22.2287,119.919 22.2469,120.104 22.3007,120.281 22.3881,120.445 22.5057,120.588 22.649,120.706 22.8126,120.793 22.99,120.847 23.1745,120.865 25.0709,120.865 25.2555,120.847 25.4329,120.793 25.5964,120.706 25.7398,120.588 25.8574,120.445 25.9448,120.281 25.9986,120.104 26.0168,119.919 25.9986,119.735 25.9448,119.557 25.8574,119.394 25.7398,119.25 25.5964,119.133 25.4329,119.045 25.2555,118.992 25.0709,118.973z"></path>
</g>
<g stroke-width="0.05" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <path d="M23.1745,118.973 A0.945847,0.945847 0 0,0 23.1745,120.865"></path>
 <path d="M25.0709,120.865 A0.945847,0.945847 0 0,0 25.0709,118.973"></path>
 <polyline points="25.0709,118.973 23.1745,118.973"></polyline>
 <polyline points="23.1745,120.865 25.0709,120.865"></polyline>
</g>
<g stroke-width="0.05" stroke="none" fill="rgb(0,0,0)">
 <text transform="matrix(1.13502 0 -0 1.13502 22.7566 120.487)" font-family="Arial,sans-serif" font-size="1.39636">T01</text>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(0,255,0)" stroke-linecap="round">
 <polyline points="32.6321,116.609 30.7799,116.609"></polyline>
 <polyline points="29.5786,116.609 27.1762,116.609"></polyline>
 <polyline points="25.975,116.609 24.1227,116.609"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(128,128,128)" stroke-linecap="round">
 <polyline points="32.6354,105.256 29.2315,105.256"></polyline>
 <polyline points="28.664,105.256 28.664,105.256"></polyline>
 <polyline points="28.0965,105.256 28.0965,105.256"></polyline>
 <polyline points="27.529,105.256 24.1251,105.256"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(255,127,0)" stroke-linecap="round">
 <polyline points="24.1251,102.418 27.9972,102.418"></polyline>
 <polyline points="29.1984,102.418 30.3996,102.418"></polyline>
 <polyline points="31.6008,102.418 35.4729,102.418"></polyline>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="30.2707,107.86 30.2707,105.968"></polyline>
 <polyline points="30.2707,105.968 32.1624,105.968"></polyline>
 <polyline points="32.1624,105.968 32.1624,107.86"></polyline>
 <polyline points="32.1624,107.86 30.2707,107.86"></polyline>
 <polyline points="31.3171,106.693 31.5519,106.767 31.7914,106.823"></polyline>
 <polyline points="31.3171,106.693 31.2516,106.664 31.2031,106.611 31.1794,106.544 31.1846,106.472 31.2177,106.408 31.2734,106.363 31.3424,106.344 31.4134,106.353 31.4749,106.39 31.5166,106.449 31.5317,106.519 31.5317,106.519 31.5245,106.753 31.4913,106.985 31.4325,107.212 31.3489,107.432 31.3489,107.432 31.3079,107.486 31.2497,107.522 31.1824,107.534 31.1154,107.52 31.0583,107.483 31.0583,107.483 30.9893,107.353 30.9406,107.214 30.913,107.07 30.9072,106.923 30.9072,106.923 30.8893,106.86 30.8488,106.808 30.7917,106.775 30.7265,106.767 30.6631,106.784 30.6108,106.824 30.5775,106.88"></polyline>
 <polyline points="26.4874,108.569 27.9061,106.914"></polyline>
 <polyline points="27.9061,106.914 30.2707,106.914"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(128,128,128)" stroke-linecap="round">
 <polyline points="32.6354,105.256 32.6357,101.945"></polyline>
 <polyline points="32.6358,101.378 32.6358,101.378"></polyline>
 <polyline points="32.6359,100.81 32.6359,100.81"></polyline>
 <polyline points="32.6359,100.243 32.6364,95.7028"></polyline>
 <polyline points="32.6365,95.1352 32.6365,95.1352"></polyline>
 <polyline points="32.6366,94.5677 32.6366,94.5677"></polyline>
 <polyline points="32.6366,94.0002 32.6371,89.4602"></polyline>
 <polyline points="32.6372,88.8927 32.6372,88.8927"></polyline>
 <polyline points="32.6373,88.3251 32.6373,88.3251"></polyline>
 <polyline points="32.6373,87.7576 32.6377,84.4472"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(255,127,0)" stroke-linecap="round">
 <polyline points="35.4753,74.0429 29.9468,74.0429"></polyline>
 <polyline points="28.7456,74.0429 27.5443,74.0429"></polyline>
 <polyline points="26.3431,74.0429 20.8146,74.0429"></polyline>
 <polyline points="35.4753,74.0429 35.4746,81.6238"></polyline>
 <polyline points="35.4745,82.825 35.4744,84.0263"></polyline>
 <polyline points="35.4743,85.2275 35.4738,91.2336"></polyline>
 <polyline points="35.4737,92.4349 35.4736,93.6361"></polyline>
 <polyline points="35.4735,94.8373 35.4729,102.418"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(128,128,128)" stroke-linecap="round">
 <polyline points="32.6377,74.0429 32.6377,78.2992"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(255,127,0)" stroke-linecap="round">
 <polyline points="24.1251,74.0429 24.1251,76.4075"></polyline>
 <polyline points="24.598,75.4617 23.6522,75.4617"></polyline>
 <polyline points="22.2334,74.0429 22.2334,76.4075"></polyline>
 <polyline points="22.7063,75.4617 21.7605,75.4617"></polyline>
</g>
<g stroke-width="0.2" stroke="none" fill="rgb(0,0,0)">
 <path stroke="none" fill="rgb(0,0,0)" d="M26.0168,74.0429 27.9085,73.57 27.9085,74.5158z"></path>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="27.9085,74.5158 27.9085,73.57"></polyline>
 <polyline points="27.9085,73.57 26.0168,74.0429"></polyline>
 <polyline points="26.0168,74.0429 27.9085,74.5158"></polyline>
</g>
<g stroke-width="0.15" fill="none" stroke="rgb(128,128,128)" stroke-linecap="round">
 <circle cx="32.6377" cy="79.4815" r="1.18231"></circle>
 <polyline points="32.6377,80.6639 33.82,79.4815"></polyline>
 <polyline points="32.6377,80.6639 31.4554,79.4815"></polyline>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(128,128,128)" stroke-linecap="round">
 <circle cx="32.6377" cy="74.0429" r="0.378339"></circle>
 <circle cx="32.6377" cy="74.0429" r="0.331046"></circle>
 <circle cx="32.6377" cy="74.0429" r="0.283754"></circle>
 <circle cx="32.6377" cy="74.0429" r="0.236462"></circle>
 <circle cx="32.6377" cy="74.0429" r="0.189169"></circle>
 <circle cx="32.6377" cy="74.0429" r="0.141877"></circle>
 <circle cx="32.6377" cy="74.0429" r="0.0945847"></circle>
 <circle cx="32.6377" cy="74.0429" r="0.0472923"></circle>
</g>
<g stroke-width="0.15" fill="none" stroke="rgb(128,128,128)" stroke-linecap="round">
 <polyline points="32.0466,84.4472 33.2289,84.4472"></polyline>
 <polyline points="32.0466,84.4472 33.2289,82.0826"></polyline>
 <polyline points="33.2289,82.0826 32.0466,82.0826"></polyline>
 <polyline points="33.2289,84.4472 33.2289,82.0826"></polyline>
 <polyline points="32.0466,84.4472 32.0466,82.0826"></polyline>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(128,128,128)" stroke-linecap="round">
 <circle cx="33.2289" cy="82.0826" r="0.378339"></circle>
 <circle cx="33.2289" cy="82.0826" r="0.331046"></circle>
 <circle cx="33.2289" cy="82.0826" r="0.283754"></circle>
 <circle cx="33.2289" cy="82.0826" r="0.236462"></circle>
 <circle cx="33.2289" cy="82.0826" r="0.189169"></circle>
 <circle cx="33.2289" cy="82.0826" r="0.141877"></circle>
 <circle cx="33.2289" cy="82.0826" r="0.0945847"></circle>
 <circle cx="33.2289" cy="82.0826" r="0.0472923"></circle>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(128,128,128)" stroke-linecap="round">
 <polyline points="32.6377,80.6638 32.6377,82.0826"></polyline>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <circle cx="24.1251" cy="109.039" r="0.472923"></circle>
 <circle cx="26.4897" cy="108.566" r="0.236462"></circle>
 <circle cx="24.1251" cy="102.418" r="0.472923"></circle>
 <circle cx="24.1251" cy="116.606" r="0.472923"></circle>
 <circle cx="24.1251" cy="105.256" r="0.472923"></circle>
 <circle cx="24.1251" cy="114.714" r="0.472923"></circle>
 <polyline points="21.2876,113.768 24.1251,113.768"></polyline>
 <polyline points="21.2876,109.985 24.1251,109.985"></polyline>
 <polyline points="21.2876,111.877 22.7063,112.823"></polyline>
 <polyline points="21.2876,113.768 22.7063,112.823"></polyline>
 <polyline points="21.2876,109.985 22.7063,110.931"></polyline>
 <polyline points="21.2876,111.877 22.7063,110.931"></polyline>
 <polyline points="19.3959,118.025 28.8543,118.025"></polyline>
 <polyline points="19.3959,118.025 19.3959,99.1077"></polyline>
 <polyline points="19.3959,100.999 28.8543,100.999"></polyline>
 <polyline points="28.8543,99.1077 28.8543,118.025"></polyline>
 <polyline points="24.1251,109.985 24.1251,109.512"></polyline>
 <polyline points="24.1251,113.768 24.1251,114.241"></polyline>
 <polyline points="19.3959,99.1077 28.8543,99.1077"></polyline>
</g>
<g stroke-width="0.2" stroke="none" fill="rgb(0,0,0)">
 <path stroke="none" fill="rgb(0,0,0)" d="M22.0493,99.7732 21.8172,99.7727 21.6421,100.122 21.4695,99.7727 21.2249,99.7732 21.5218,100.317 21.7629,100.317z M22.3438,99.7736 22.1368,99.7727 22.1368,100.317 22.3438,100.317z M23.0342,99.9714 22.7242,99.9714 22.7242,99.9081 23.1,99.9081 23.1,99.7727 22.5286,99.7727 22.5286,100.317 23.1186,100.317 23.1186,100.17 22.7242,100.17 22.7242,100.097 23.0342,100.097z M23.838,99.8687 23.8408,99.85 23.8417,99.8305 23.8413,99.8197 23.8395,99.8007 23.8356,99.7825 23.8301,99.765 23.8225,99.7482 23.8133,99.7324 23.8023,99.7171 23.7892,99.7027 23.7817,99.6955 23.7669,99.6835 23.7513,99.6734 23.7349,99.6651 23.7177,99.6587 23.6999,99.6541 23.6813,99.6513 23.6619,99.6504 23.388,99.6504 23.3711,99.6471 23.3602,99.6366 23.3565,99.6189 23.3597,99.6023 23.3702,99.5914 23.388,99.5879 23.8233,99.5879 23.8233,99.4421 23.3626,99.4421 23.344,99.4426 23.326,99.4452 23.3085,99.45 23.2915,99.4568 23.2753,99.466 23.2598,99.4771 23.2447,99.4905 23.2399,99.4955 23.2274,99.51 23.2167,99.5253 23.2077,99.5413 23.2007,99.5583 23.1956,99.576 23.1922,99.5946 23.1908,99.6139 23.1908,99.6189 23.1909,99.6257 23.1926,99.6449 23.1959,99.6631 23.2013,99.6808 23.2084,99.6975 23.2175,99.7137 23.2285,99.729 23.2412,99.7438 23.2449,99.7475 23.2593,99.7603 23.2744,99.7712 23.2904,99.7802 23.3072,99.7872 23.3249,99.7922 23.3433,99.7952 23.3626,99.7961 23.6376,99.7961 23.6531,99.7988 23.6643,99.809 23.668,99.8267 23.6652,99.8421 23.6551,99.8534 23.6376,99.857 23.1948,99.857 23.1948,100.01 23.6619,100.01 23.6726,100.01 23.6916,100.008 23.7098,100.004 23.7271,99.9987 23.7439,99.9911 23.7597,99.9817 23.7748,99.9705 23.7892,99.9574 23.7962,99.9502 23.8082,99.9353 23.8185,99.9199 23.8268,99.9036 23.8332,99.8865z M23.8233,100.097 23.3626,100.097 23.344,100.097 23.326,100.1 23.3085,100.105 23.2915,100.112 23.2753,100.121 23.2598,100.132 23.2447,100.145 23.2399,100.15 23.2274,100.165 23.2167,100.18 23.2077,100.196 23.2007,100.213 23.1956,100.231 23.1922,100.249 23.1908,100.269 23.1908,100.274 23.1909,100.28 23.1926,100.299 23.1959,100.318 23.2013,100.335 23.2084,100.352 23.2175,100.368 23.2285,100.384 23.2412,100.398 23.2449,100.402 23.2593,100.415 23.2744,100.426 23.2904,100.435 23.3072,100.442 23.3249,100.447 23.3433,100.45 23.3626,100.451 23.6376,100.451 23.6531,100.453 23.6643,100.464 23.668,100.481 23.6652,100.497 23.6551,100.508 23.6376,100.512 23.1948,100.512 23.1948,100.665 23.6619,100.665 23.6726,100.665 23.6916,100.663 23.7098,100.659 23.7271,100.653 23.7439,100.646 23.7597,100.636 23.7748,100.625 23.7892,100.612 23.7962,100.605 23.8082,100.59 23.8185,100.575 23.8268,100.558 23.8332,100.541 23.838,100.523 23.8408,100.505 23.8417,100.485 23.8413,100.474 23.8395,100.455 23.8356,100.437 23.8301,100.42 23.8225,100.403 23.8133,100.387 23.8023,100.372 23.7892,100.357 23.7817,100.35 23.7669,100.338 23.7513,100.328 23.7349,100.32 23.7177,100.313 23.6999,100.309 23.6813,100.306 23.6619,100.305 23.388,100.305 23.3711,100.302 23.3602,100.291 23.3565,100.274 23.3597,100.257 23.3702,100.246 23.388,100.243 23.8233,100.243z M24.2355,99.7727 23.9559,99.7727 23.9559,100.317 24.1392,100.317 24.1392,100.026 24.2664,100.317 24.3937,100.317 24.5274,100.011 24.5274,100.317 24.7015,100.317 24.7015,99.7727 24.4261,99.7727 24.3318,100.018z M25.2436,99.7732 25.0156,99.7732 24.7394,100.317 24.9596,100.317 25.0106,100.221 25.0163,100.221 25.0524,100.22 25.0854,100.22 25.115,100.22 25.1419,100.22 25.1655,100.22 25.1861,100.22 25.2036,100.22 25.218,100.22 25.2292,100.22 25.2375,100.22 25.2446,100.22 25.2955,100.317 25.5156,100.317z M25.7881,99.7727 25.583,99.7727 25.583,100.317 25.7881,100.317 25.7881,100.041 26.0192,100.317 26.2194,100.317 26.2194,99.7727 26.0222,99.7727 26.0222,100.043z M26.5941,99.7727 26.3891,99.7727 26.3891,100.317 26.5941,100.317 26.5941,100.041 26.8252,100.317 27.0255,100.317 27.0255,99.7727 26.8282,99.7727 26.8282,100.043z M25.0599,100.077 25.1268,99.9539 25.1931,100.077z"></path>
</g>
<g stroke-width="0.05" stroke="none" fill="rgb(153,255,153)">
 <path stroke="none" fill="rgb(153,255,153)" d="M31.2213,75.9346 29.3249,75.9346 29.1404,75.9528 28.9629,76.0066 28.7994,76.094 28.6561,76.2116 28.5384,76.355 28.451,76.5185 28.3972,76.6959 28.379,76.8805 28.3972,77.065 28.451,77.2424 28.5384,77.4059 28.6561,77.5493 28.7994,77.6669 28.9629,77.7543 29.1404,77.8081 29.3249,77.8263 31.2213,77.8263 31.4058,77.8081 31.5833,77.7543 31.7468,77.6669 31.8901,77.5493 32.0078,77.4059 32.0952,77.2424 32.149,77.065 32.1672,76.8805 32.149,76.6959 32.0952,76.5185 32.0078,76.355 31.8901,76.2116 31.7468,76.094 31.5833,76.0066 31.4058,75.9528 31.2213,75.9346z"></path>
</g>
<g stroke-width="0.05" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <path d="M29.3249,75.9346 A0.945847,0.945847 0 0,0 29.3249,77.8263"></path>
 <path d="M31.2213,77.8263 A0.945847,0.945847 0 0,0 31.2213,75.9346"></path>
 <polyline points="31.2213,75.9346 29.3249,75.9346"></polyline>
 <polyline points="29.3249,77.8263 31.2213,77.8263"></polyline>
</g>
<g stroke-width="0.05" stroke="none" fill="rgb(0,0,0)">
 <text transform="matrix(1.13502 0 -0 1.13502 28.907 77.448)" font-family="Arial,sans-serif" font-size="1.39636">T40</text>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(0,255,0)" stroke-linecap="round">
 <polyline points="32.6321,126.064 32.6321,123.739"></polyline>
 <polyline points="32.6321,122.538 32.6321,120.135"></polyline>
 <polyline points="32.6321,118.934 32.6321,116.609"></polyline>
 <polyline points="32.6321,126.064 31.0099,126.064"></polyline>
 <polyline points="29.8087,126.064 27.4062,126.064"></polyline>
 <polyline points="26.205,126.064 24.5828,126.064"></polyline>
</g>
<g stroke-width="0.05" stroke="none" fill="rgb(153,255,153)">
 <path stroke="none" fill="rgb(153,255,153)" d="M22.4571,128.424 20.5606,128.424 20.3761,128.442 20.1987,128.496 20.0351,128.584 19.8918,128.701 19.7742,128.845 19.6868,129.008 19.633,129.186 19.6148,129.37 19.633,129.555 19.6868,129.732 19.7742,129.896 19.8918,130.039 20.0351,130.157 20.1987,130.244 20.3761,130.298 20.5606,130.316 22.4571,130.316 22.6416,130.298 22.819,130.244 22.9825,130.157 23.1259,130.039 23.2435,129.896 23.3309,129.732 23.3847,129.555 23.4029,129.37 23.3847,129.186 23.3309,129.008 23.2435,128.845 23.1259,128.701 22.9825,128.584 22.819,128.496 22.6416,128.442 22.4571,128.424z"></path>
</g>
<g stroke-width="0.05" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <path d="M20.5606,128.424 A0.945847,0.945847 0 0,0 20.5606,130.316"></path>
 <path d="M22.4571,130.316 A0.945847,0.945847 0 0,0 22.4571,128.424"></path>
 <polyline points="22.4571,128.424 20.5606,128.424"></polyline>
 <polyline points="20.5606,130.316 22.4571,130.316"></polyline>
</g>
<g stroke-width="0.05" stroke="none" fill="rgb(0,0,0)">
 <text transform="matrix(1.13502 0 -0 1.13502 20.1427 129.938)" font-family="Arial,sans-serif" font-size="1.39636">Z59</text>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="26.8176,123.792 27.2166,123.692"></polyline>
 <polyline points="27.2166,123.692 26.4186,123.493"></polyline>
 <polyline points="26.4186,123.493 27.2166,123.293"></polyline>
 <polyline points="27.2166,123.293 26.4186,123.094"></polyline>
 <polyline points="26.4186,123.094 27.2166,122.894"></polyline>
 <polyline points="27.2166,122.894 26.8176,122.743"></polyline>
 <polyline points="26.8176,122.743 26.8176,122.296"></polyline>
 <polyline points="26.8176,123.792 26.8176,124.291"></polyline>
 <polyline points="27.8842,123.764 27.8842,124.828"></polyline>
 <polyline points="27.8842,124.828 26.8201,124.296"></polyline>
 <polyline points="27.8842,123.764 26.8201,124.296"></polyline>
 <polyline points="27.3496,125.355 26.2856,125.355"></polyline>
 <polyline points="26.2856,125.355 26.8176,124.291"></polyline>
 <polyline points="27.3496,125.355 26.8176,124.291"></polyline>
 <polyline points="27.3496,125.089 26.2856,125.089"></polyline>
 <circle cx="26.0016" cy="129.611" r="1.41877"></circle>
 <polyline points="24.441,129.469 27.5623,129.469"></polyline>
 <polyline points="24.441,129.753 27.5623,129.753"></polyline>
 <polyline points="22.4547,126.596 22.4547,125.532"></polyline>
 <polyline points="22.4547,125.532 21.3906,126.064"></polyline>
 <polyline points="22.4547,126.596 21.3906,126.064"></polyline>
 <polyline points="20.3265,125.532 20.3265,126.596"></polyline>
 <polyline points="20.3265,126.596 21.3906,126.064"></polyline>
 <polyline points="20.3265,125.532 21.3906,126.064"></polyline>
</g>
<g stroke-width="0.25" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="23.4744,125.51 24.5828,126.064"></polyline>
 <polyline points="24.5828,126.064 23.4744,126.619"></polyline>
</g>
<g stroke-width="0.25" stroke="none" fill="rgb(0,0,0)">
 <path stroke="none" fill="rgb(0,0,0)" d="M24.5828,126.064 23.4744,126.619 23.4744,125.51 24.5828,126.064z"></path>
</g>
<g stroke-width="0.25" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="24.5828,126.619 24.5828,125.51"></polyline>
 <polyline points="23.4744,126.619 23.4744,125.51"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(0,255,0)" stroke-linecap="round">
 <polyline points="22.4547,126.064 23.4744,126.064"></polyline>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="25.1149,126.064 25.1149,125"></polyline>
 <polyline points="26.8176,126.064 26.8176,125.355"></polyline>
</g>
<g stroke-width="0.15" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="19.9718,127.838 19.9718,126.805"></polyline>
 <polyline points="19.9718,126.445 19.9718,126.084"></polyline>
 <polyline points="19.9718,125.724 19.9718,123.922"></polyline>
 <polyline points="19.9718,123.562 19.9718,123.201"></polyline>
 <polyline points="19.9718,122.841 19.9718,121.808"></polyline>
 <polyline points="19.9718,121.808 22.0688,121.808"></polyline>
 <polyline points="22.4292,121.808 22.7895,121.808"></polyline>
 <polyline points="23.1499,121.808 24.9517,121.808"></polyline>
 <polyline points="25.3121,121.808 25.6725,121.808"></polyline>
 <polyline points="26.0328,121.808 28.1298,121.808"></polyline>
 <polyline points="28.1298,121.808 28.1298,122.841"></polyline>
 <polyline points="28.1298,123.201 28.1298,123.562"></polyline>
 <polyline points="28.1298,123.922 28.1298,125.724"></polyline>
 <polyline points="28.1298,126.084 28.1298,126.445"></polyline>
 <polyline points="28.1298,126.805 28.1298,127.838"></polyline>
 <polyline points="28.1298,127.838 26.0328,127.838"></polyline>
 <polyline points="25.6725,127.838 25.3121,127.838"></polyline>
 <polyline points="24.9517,127.838 23.1499,127.838"></polyline>
 <polyline points="22.7895,127.838 22.4292,127.838"></polyline>
 <polyline points="22.0688,127.838 19.9718,127.838"></polyline>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="26.0016,126.596 26.0016,126.064"></polyline>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,255,0)" stroke-linecap="round">
 <circle cx="26.0016" cy="126.064" r="0.283754"></circle>
 <circle cx="26.0016" cy="126.064" r="0.248285"></circle>
 <circle cx="26.0016" cy="126.064" r="0.212816"></circle>
 <circle cx="26.0016" cy="126.064" r="0.177346"></circle>
 <circle cx="26.0016" cy="126.064" r="0.141877"></circle>
 <circle cx="26.0016" cy="126.064" r="0.106408"></circle>
 <circle cx="26.0016" cy="126.064" r="0.0709385"></circle>
 <circle cx="26.0016" cy="126.064" r="0.0354693"></circle>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(0,255,0)" stroke-linecap="round">
 <polyline points="20.3265,126.064 17.8948,126.064"></polyline>
 <polyline points="16.6936,126.064 14.2618,126.064"></polyline>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="26.2676,126.596 25.7356,126.596"></polyline>
 <polyline points="25.7356,126.596 26.0016,127.128"></polyline>
 <polyline points="26.2676,126.596 26.0016,127.128"></polyline>
 <polyline points="25.7356,127.66 26.2676,127.66"></polyline>
 <polyline points="26.2676,127.66 26.0016,127.128"></polyline>
 <polyline points="25.7356,127.66 26.0016,127.128"></polyline>
 <polyline points="26.0016,127.128 25.6469,127.128"></polyline>
 <polyline points="25.6469,126.951 25.6469,127.306"></polyline>
 <polyline points="25.5583,126.862 25.5583,127.394"></polyline>
 <polyline points="25.5583,127.394 25.7356,127.394"></polyline>
 <polyline points="25.5583,126.862 25.7356,126.862"></polyline>
 <polyline points="26.0016,128.193 26.0016,127.66"></polyline>
 <polyline points="24.8504,124.771 24.8504,123.909"></polyline>
 <polyline points="24.8504,123.909 25.2179,123.909"></polyline>
 <polyline points="25.2179,123.909 25.3384,123.949"></polyline>
 <polyline points="25.3384,123.949 25.3825,123.993"></polyline>
 <polyline points="25.3825,123.993 25.4236,124.071"></polyline>
 <polyline points="25.4236,124.071 25.423,124.198"></polyline>
 <polyline points="25.423,124.198 25.3832,124.279"></polyline>
 <polyline points="25.3832,124.279 25.3414,124.32"></polyline>
 <polyline points="25.3414,124.32 25.2206,124.361"></polyline>
 <polyline points="25.2206,124.361 24.8504,124.361"></polyline>
 <circle cx="25.1149" cy="124.291" r="0.709385"></circle>
</g>
<g stroke-width="0.25" stroke="none" fill="rgb(63,255,0)">
 <path stroke="none" fill="rgb(63,255,0)" d="M15.5485,125.555 15.5485,126.576 17.251,126.066z"></path>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(255,0,0)" stroke-linecap="round">
 <polyline points="67.1588,109.512 67.1588,111.877"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(0,41,165)" stroke-linecap="round">
 <polyline points="69.9963,109.512 69.9963,111.129"></polyline>
 <polyline points="69.9963,112.331 69.9963,114.733"></polyline>
 <polyline points="69.9963,115.934 69.9963,117.552"></polyline>
 <polyline points="92.699,117.552 89.865,117.552"></polyline>
 <polyline points="88.6638,117.552 86.2613,117.552"></polyline>
 <polyline points="85.0601,117.552 82.6576,117.552"></polyline>
 <polyline points="81.4564,117.552 79.054,117.552"></polyline>
 <polyline points="77.8527,117.552 75.4503,117.552"></polyline>
 <polyline points="74.2491,117.552 71.4151,117.552"></polyline>
 <polyline points="69.9963,117.552 67.841,117.552"></polyline>
 <polyline points="66.6397,117.552 64.2373,117.552"></polyline>
 <polyline points="63.0361,117.552 60.6336,117.552"></polyline>
 <polyline points="59.4324,117.552 57.0299,117.552"></polyline>
 <polyline points="55.8287,117.552 53.4263,117.552"></polyline>
 <polyline points="52.225,117.552 49.8226,117.552"></polyline>
 <polyline points="48.6213,117.552 46.2189,117.552"></polyline>
 <polyline points="45.0177,117.552 42.6152,117.552"></polyline>
 <polyline points="41.414,117.552 39.2586,117.552"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(255,0,0)" stroke-linecap="round">
 <polyline points="67.1588,111.877 42.0962,111.877"></polyline>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <circle cx="71.4151" cy="120.309" r="1.89169"></circle>
 <polyline points="69.3342,120.498 73.4959,120.498"></polyline>
 <polyline points="69.3342,120.12 73.4959,120.12"></polyline>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,41,165)" stroke-linecap="round">
 <circle cx="71.4151" cy="117.552" r="0.378339"></circle>
 <circle cx="71.4151" cy="117.552" r="0.331046"></circle>
 <circle cx="71.4151" cy="117.552" r="0.283754"></circle>
 <circle cx="71.4151" cy="117.552" r="0.236462"></circle>
 <circle cx="71.4151" cy="117.552" r="0.189169"></circle>
 <circle cx="71.4151" cy="117.552" r="0.141877"></circle>
 <circle cx="71.4151" cy="117.552" r="0.0945847"></circle>
 <circle cx="71.4151" cy="117.552" r="0.0472923"></circle>
</g>
<g stroke-width="0.05" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <path d="M70.4692,122.674 A0.945847,0.945847 0 0,0 70.4692,124.566"></path>
 <path d="M72.3609,124.566 A0.945847,0.945847 0 0,0 72.3609,122.674"></path>
 <polyline points="72.3609,122.674 70.4692,122.674"></polyline>
 <polyline points="70.4692,124.566 72.3609,124.566"></polyline>
</g>
<g stroke-width="0.05" stroke="none" fill="rgb(0,0,0)">
 <text transform="matrix(1.13502 0 -0 1.13502 70.049 124.187)" font-family="Arial,sans-serif" font-size="1.39636">Z02</text>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="71.4151,117.552 71.4151,118.417"></polyline>
</g>
<g stroke-width="0.2" stroke="none" fill="rgb(0,0,0)">
 <text transform="matrix(1.18231 0 -0 1.18231 32.6065 107.374)" font-family="Arial,sans-serif" font-size="1.39636">-G02A/3;4-</text>
</g>
<g stroke-width="0.05" stroke="none" fill="rgb(153,255,153)">
 <path stroke="none" fill="rgb(153,255,153)" d="M43.8163,106.105 41.9199,106.105 41.7353,106.124 41.5579,106.177 41.3944,106.265 41.251,106.382 41.1334,106.526 41.046,106.689 40.9922,106.867 40.974,107.051 40.9922,107.236 41.046,107.413 41.1334,107.577 41.251,107.72 41.3944,107.838 41.5579,107.925 41.7353,107.979 41.9199,107.997 43.8163,107.997 44.0008,107.979 44.1782,107.925 44.3418,107.838 44.4851,107.72 44.6027,107.577 44.6901,107.413 44.744,107.236 44.7621,107.051 44.744,106.867 44.6901,106.689 44.6027,106.526 44.4851,106.382 44.3418,106.265 44.1782,106.177 44.0008,106.124 43.8163,106.105z"></path>
</g>
<g stroke-width="0.05" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <path d="M41.9199,106.105 A0.945847,0.945847 0 0,0 41.9199,107.997"></path>
 <path d="M43.8163,107.997 A0.945847,0.945847 0 0,0 43.8163,106.105"></path>
 <polyline points="43.8163,106.105 41.9199,106.105"></polyline>
 <polyline points="41.9199,107.997 43.8163,107.997"></polyline>
</g>
<g stroke-width="0.05" stroke="none" fill="rgb(0,0,0)">
 <text transform="matrix(1.13502 0 -0 1.13502 41.3696 107.619)" font-family="Arial,sans-serif" font-size="1.39636">G05</text>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(255,0,0)" stroke-linecap="round">
 <polyline points="65.74,109.512 65.74,114.005"></polyline>
 <polyline points="65.74,114.005 83.2405,114.005"></polyline>
 <polyline points="83.2405,114.005 83.2405,54.4165"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(0,41,165)" stroke-linecap="round">
 <polyline points="71.4151,109.512 71.4151,111.129"></polyline>
 <polyline points="71.4151,112.331 71.4151,114.733"></polyline>
 <polyline points="71.4151,115.934 71.4151,117.552"></polyline>
 <polyline points="92.699,54.4165 92.699,56.5541"></polyline>
 <polyline points="92.699,57.7553 92.699,60.1578"></polyline>
 <polyline points="92.699,61.359 92.699,63.7614"></polyline>
 <polyline points="92.699,64.9627 92.699,67.3651"></polyline>
 <polyline points="92.699,68.5663 92.699,70.9688"></polyline>
 <polyline points="92.699,72.17 92.699,74.5725"></polyline>
 <polyline points="92.699,75.7737 92.699,78.1761"></polyline>
 <polyline points="92.699,79.3774 92.699,81.7798"></polyline>
 <polyline points="92.699,82.981 92.699,85.3835"></polyline>
 <polyline points="92.699,86.5847 92.699,88.9872"></polyline>
 <polyline points="92.699,90.1884 92.699,92.5909"></polyline>
 <polyline points="92.699,93.7921 92.699,96.1945"></polyline>
 <polyline points="92.699,97.3958 92.699,99.7982"></polyline>
 <polyline points="92.699,100.999 92.699,103.402"></polyline>
 <polyline points="92.699,104.603 92.699,107.006"></polyline>
 <polyline points="92.699,108.207 92.699,110.609"></polyline>
 <polyline points="92.699,111.81 92.699,114.213"></polyline>
 <polyline points="92.699,115.414 92.699,117.552"></polyline>
</g>
<g stroke-width="0.2" stroke="none" fill="rgb(128,128,128)">
 <text transform="matrix(1.18231 0 -0 1.18231 24.2659 79.9805)" font-family="Arial,sans-serif" font-size="1.39636">-G02/P2--</text>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(255,0,0)" stroke-linecap="round">
 <polyline points="24.1251,109.039 42.0962,109.039"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(0,41,165)" stroke-linecap="round">
 <polyline points="24.1251,114.714 25.6857,114.714"></polyline>
 <polyline points="26.887,114.714 29.2894,114.714"></polyline>
 <polyline points="30.4906,114.714 32.8931,114.714"></polyline>
 <polyline points="34.0943,114.714 36.4968,114.714"></polyline>
 <polyline points="37.698,114.714 39.2586,114.714"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(255,0,0)" stroke-linecap="round">
 <polyline points="42.0962,109.039 42.0962,111.877"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(0,41,165)" stroke-linecap="round">
 <polyline points="39.2586,114.714 39.2586,117.552"></polyline>
</g>
<g stroke-width="0.2" stroke="none" fill="rgb(179,179,179)">
 <text transform="matrix(0.0472923 0 -0 0.0472923 0 138.171)" font-family="Arial,sans-serif" font-size="1.39636">.</text>
 <text transform="matrix(0.0472923 0 -0 0.0472923 174.982 0.0775803)" font-family="Arial,sans-serif" font-size="1.39636">.</text>
</g>
<g stroke-width="0.05" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <path d="M67.6317,96.7431 A0.945847,0.945847 0 0,0 67.6317,98.6348"></path>
 <path d="M69.5234,98.6348 A0.945847,0.945847 0 0,0 69.5234,96.7431"></path>
 <polyline points="69.5234,96.7431 67.6317,96.7431"></polyline>
 <polyline points="67.6317,98.6348 69.5234,98.6348"></polyline>
</g>
<g stroke-width="0.05" stroke="none" fill="rgb(0,0,0)">
 <text transform="matrix(1.13502 0 -0 1.13502 67.079 98.2565)" font-family="Arial,sans-serif" font-size="1.39636">G01</text>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="64.7941,99.1077 72.3609,99.1077"></polyline>
 <polyline points="72.3609,99.1077 72.3609,109.512"></polyline>
 <polyline points="72.3609,109.512 64.7941,109.512"></polyline>
 <polyline points="64.7941,109.512 64.7941,99.1077"></polyline>
</g>
<g stroke-width="0.2" stroke="none" fill="rgb(0,0,0)">
 <path stroke="none" fill="rgb(0,0,0)" d="M66.5018,99.7732 66.2697,99.7727 66.0945,100.122 65.9219,99.7727 65.6773,99.7732 65.9742,100.317 66.2153,100.317z M66.7963,99.7736 66.5893,99.7727 66.5893,100.317 66.7963,100.317z M67.4866,99.9714 67.1766,99.9714 67.1766,99.9081 67.5524,99.9081 67.5524,99.7727 66.981,99.7727 66.981,100.317 67.571,100.317 67.571,100.17 67.1766,100.17 67.1766,100.097 67.4866,100.097z M68.2904,99.8687 68.2932,99.85 68.2941,99.8305 68.2938,99.8197 68.2919,99.8007 68.2881,99.7825 68.2825,99.765 68.275,99.7482 68.2658,99.7324 68.2547,99.7171 68.2416,99.7027 68.2341,99.6955 68.2194,99.6835 68.2037,99.6734 68.1873,99.6651 68.1702,99.6587 68.1523,99.6541 68.1337,99.6513 68.1144,99.6504 67.8405,99.6504 67.8235,99.6471 67.8127,99.6366 67.809,99.6189 67.8121,99.6023 67.8226,99.5914 67.8405,99.5879 68.2757,99.5879 68.2757,99.4421 67.8151,99.4421 67.7964,99.4426 67.7784,99.4452 67.7609,99.45 67.744,99.4568 67.7277,99.466 67.7123,99.4771 67.6972,99.4905 67.6924,99.4955 67.6799,99.51 67.6692,99.5253 67.6601,99.5413 67.6531,99.5583 67.648,99.576 67.6447,99.5946 67.6432,99.6139 67.6432,99.6189 67.6434,99.6257 67.645,99.6449 67.6484,99.6631 67.6537,99.6808 67.6609,99.6975 67.6699,99.7137 67.681,99.729 67.6937,99.7438 67.6974,99.7475 67.7117,99.7603 67.7268,99.7712 67.7428,99.7802 67.7596,99.7872 67.7773,99.7922 67.7957,99.7952 67.8151,99.7961 68.09,99.7961 68.1055,99.7988 68.1168,99.809 68.1204,99.8267 68.1177,99.8421 68.1075,99.8534 68.09,99.857 67.6473,99.857 67.6473,100.01 68.1144,100.01 68.125,100.01 68.144,100.008 68.1623,100.004 68.1796,99.9987 68.1963,99.9911 68.2122,99.9817 68.2273,99.9705 68.2416,99.9574 68.2486,99.9503 68.2606,99.9353 68.2709,99.9199 68.2792,99.9036 68.2857,99.8865z M68.2757,100.097 67.8151,100.097 67.7964,100.097 67.7784,100.1 67.7609,100.105 67.744,100.112 67.7277,100.121 67.7123,100.132 67.6972,100.145 67.6924,100.15 67.6799,100.165 67.6692,100.18 67.6601,100.196 67.6531,100.213 67.648,100.231 67.6447,100.249 67.6432,100.269 67.6432,100.274 67.6434,100.28 67.645,100.299 67.6484,100.318 67.6537,100.335 67.6609,100.352 67.6699,100.368 67.681,100.384 67.6937,100.398 67.6974,100.402 67.7117,100.415 67.7268,100.426 67.7428,100.435 67.7596,100.442 67.7773,100.447 67.7957,100.45 67.8151,100.451 68.09,100.451 68.1055,100.453 68.1168,100.464 68.1204,100.481 68.1177,100.497 68.1075,100.508 68.09,100.512 67.6473,100.512 67.6473,100.665 68.1144,100.665 68.125,100.665 68.144,100.663 68.1623,100.659 68.1796,100.653 68.1963,100.646 68.2122,100.636 68.2273,100.625 68.2416,100.612 68.2486,100.605 68.2606,100.59 68.2709,100.575 68.2792,100.558 68.2857,100.541 68.2904,100.523 68.2932,100.505 68.2941,100.485 68.2938,100.474 68.2919,100.455 68.2881,100.437 68.2825,100.42 68.275,100.403 68.2658,100.387 68.2547,100.372 68.2416,100.357 68.2341,100.35 68.2194,100.338 68.2037,100.328 68.1873,100.32 68.1702,100.313 68.1523,100.309 68.1337,100.306 68.1144,100.305 67.8405,100.305 67.8235,100.302 67.8127,100.291 67.809,100.274 67.8121,100.257 67.8226,100.246 67.8405,100.243 68.2757,100.243z M68.6879,99.7727 68.4083,99.7727 68.4083,100.317 68.5916,100.317 68.5916,100.026 68.7189,100.317 68.8462,100.317 68.9799,100.011 68.9799,100.317 69.1539,100.317 69.1539,99.7727 68.8786,99.7727 68.7843,100.018z M69.696,99.7732 69.468,99.7732 69.1919,100.317 69.412,100.317 69.463,100.221 69.4687,100.221 69.5048,100.22 69.5378,100.22 69.5675,100.22 69.5943,100.22 69.6179,100.22 69.6385,100.22 69.656,100.22 69.6704,100.22 69.6817,100.22 69.6899,100.22 69.697,100.22 69.748,100.317 69.9681,100.317z M70.2405,99.7727 70.0355,99.7727 70.0355,100.317 70.2405,100.317 70.2405,100.041 70.4716,100.317 70.6719,100.317 70.6719,99.7727 70.4746,99.7727 70.4746,100.043z M71.0465,99.7727 70.8415,99.7727 70.8415,100.317 71.0465,100.317 71.0465,100.041 71.2777,100.317 71.4779,100.317 71.4779,99.7727 71.2806,99.7727 71.2806,100.043z M69.5124,100.077 69.5792,99.9539 69.6455,100.077z"></path>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="64.7477,130.321 72.3144,130.321"></polyline>
 <polyline points="72.3144,130.321 72.3144,133.158"></polyline>
 <polyline points="72.3144,133.158 64.7477,133.158"></polyline>
 <polyline points="64.7477,130.321 64.7477,133.158"></polyline>
 <polyline points="61.4837,100.999 61.4837,99.1077"></polyline>
 <polyline points="61.4837,99.1077 63.3754,99.1077"></polyline>
 <polyline points="63.3754,99.1077 63.3754,100.999"></polyline>
 <polyline points="63.3754,100.999 61.4837,100.999"></polyline>
 <path d="M62.5301,99.8328 A3.34215,3.34215 0 0,0 63.0044,99.963"></path>
 <path d="M62.7446,99.6585 A0.176885,0.176885 0 1,0 62.5301,99.8328"></path>
 <path d="M62.5619,100.571 A2.10957,2.10957 0 0,0 62.7446,99.6585"></path>
 <path d="M62.2712,100.622 A0.182378,0.182378 0 0,0 62.5619,100.571"></path>
 <path d="M62.1202,100.062 A0.983792,0.983792 0 0,0 62.2712,100.622"></path>
 <path d="M62.1202,100.062 A0.169956,0.169956 0 0,0 61.7904,100.02"></path>
</g>
<g stroke-width="0.05" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <path d="M61.4837,96.7431 A0.945847,0.945847 0 0,0 61.4837,98.6348"></path>
 <path d="M63.3754,98.6348 A0.945847,0.945847 0 0,0 63.3754,96.7431"></path>
 <polyline points="63.3754,96.7431 61.4837,96.7431"></polyline>
 <polyline points="61.4837,98.6348 63.3754,98.6348"></polyline>
</g>
<g stroke-width="0.05" stroke="none" fill="rgb(0,0,0)">
 <text transform="matrix(1.13502 0 -0 1.13502 60.931 98.2565)" font-family="Arial,sans-serif" font-size="1.39636">G11</text>
</g>
<g stroke-width="0.2" stroke="none" fill="rgb(0,0,0)">
 <text transform="matrix(1.18231 0 -0 1.18231 53.1916 100.538)" font-family="Arial,sans-serif" font-size="1.39636">-G02A/1;2-</text>
</g>
<g stroke-width="0.05" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <path d="M67.5852,130.794 A0.945847,0.945847 0 0,0 67.5852,132.685"></path>
 <path d="M69.4769,132.685 A0.945847,0.945847 0 0,0 69.4769,130.794"></path>
 <polyline points="69.4769,130.794 67.5852,130.794"></polyline>
 <polyline points="67.5852,132.685 69.4769,132.685"></polyline>
</g>
<g stroke-width="0.05" stroke="none" fill="rgb(0,0,0)">
 <text transform="matrix(1.13502 0 -0 1.13502 67.0325 132.307)" font-family="Arial,sans-serif" font-size="1.39636">G02</text>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="67.1588,108.093 67.1588,109.512"></polyline>
 <polyline points="65.74,104.783 65.74,107.147"></polyline>
 <polyline points="65.74,108.093 65.74,109.512"></polyline>
 <polyline points="71.4151,108.093 71.4151,109.512"></polyline>
 <polyline points="71.4151,108.093 71.4151,106.675"></polyline>
 <polyline points="71.4151,105.256 71.4151,104.783"></polyline>
 <polyline points="65.74,108.093 67.1588,108.093"></polyline>
 <polyline points="71.4151,108.093 69.9963,108.093"></polyline>
 <polyline points="69.9963,108.093 69.9963,109.512"></polyline>
 <polyline points="67.4941,104.523 69.5208,104.523 69.5208,104.808 67.4941,104.808 67.4941,104.523"></polyline>
 <polyline points="68.707,104.169 68.7351,104.075 68.7531,104.003 68.7651,103.946 68.777,103.88 68.7897,103.787 68.7972,103.703 68.7999,103.653 68.8015,103.589 68.8008,103.518 68.7991,103.473 68.797,103.438 68.7934,103.392 68.7895,103.353 68.7847,103.313 68.7795,103.277 68.7716,103.228 68.761,103.173 68.7476,103.113 68.734,103.061 68.7155,102.997 68.6993,102.948 68.6769,102.887 68.6595,102.843 68.6448,102.809 68.6308,102.778 68.6158,102.747 68.5985,102.713 68.579,102.676 68.5568,102.638 68.5253,102.587 68.5079,102.56 68.4983,102.546 68.4866,102.529"></polyline>
 <polyline points="68.707,104.169 68.7347,104.137"></polyline>
 <polyline points="68.7347,104.137 68.7588,104.108"></polyline>
 <polyline points="68.7588,104.108 68.7809,104.08"></polyline>
 <polyline points="68.7809,104.08 68.8036,104.051"></polyline>
 <polyline points="68.8036,104.051 68.8272,104.019"></polyline>
 <polyline points="68.8272,104.019 68.8416,103.999"></polyline>
 <polyline points="68.8416,103.999 68.8576,103.976"></polyline>
 <polyline points="68.8576,103.976 68.8725,103.954"></polyline>
 <polyline points="68.8725,103.954 68.8874,103.932"></polyline>
 <polyline points="68.8874,103.932 68.9029,103.908"></polyline>
 <polyline points="68.9029,103.908 68.9164,103.887"></polyline>
 <polyline points="68.9164,103.887 68.9314,103.862"></polyline>
 <polyline points="68.9314,103.862 68.945,103.839"></polyline>
 <polyline points="68.945,103.839 68.9643,103.806"></polyline>
 <polyline points="68.9643,103.806 68.9753,103.786"></polyline>
 <polyline points="68.9753,103.786 68.9903,103.758"></polyline>
 <polyline points="68.9903,103.758 69.0039,103.732"></polyline>
 <polyline points="69.0039,103.732 69.0182,103.703"></polyline>
 <polyline points="69.0182,103.703 69.0317,103.675"></polyline>
 <polyline points="69.0317,103.675 69.0452,103.645"></polyline>
 <polyline points="69.0452,103.645 69.0569,103.619"></polyline>
 <polyline points="69.0569,103.619 69.0705,103.586"></polyline>
 <polyline points="69.0705,103.586 69.0785,103.567"></polyline>
 <polyline points="69.0785,103.567 69.0876,103.543"></polyline>
 <polyline points="69.0876,103.543 69.095,103.523"></polyline>
 <polyline points="69.095,103.523 69.1042,103.498"></polyline>
 <polyline points="69.1042,103.498 69.1111,103.478"></polyline>
 <polyline points="69.1111,103.478 69.1208,103.448"></polyline>
 <polyline points="69.1208,103.448 69.1299,103.419"></polyline>
 <polyline points="69.1299,103.419 69.1383,103.391"></polyline>
 <polyline points="69.1383,103.391 69.1501,103.347"></polyline>
 <polyline points="69.1501,103.347 69.159,103.311"></polyline>
 <polyline points="69.159,103.311 69.1677,103.272"></polyline>
 <polyline points="69.1677,103.272 69.1758,103.232"></polyline>
 <polyline points="69.1758,103.232 69.1831,103.192"></polyline>
 <polyline points="69.1831,103.192 69.1907,103.142"></polyline>
 <polyline points="69.1907,103.142 69.197,103.091"></polyline>
 <polyline points="69.197,103.091 69.2022,103.036"></polyline>
 <polyline points="69.2022,103.036 69.2043,103.006"></polyline>
 <polyline points="69.2043,103.006 69.2066,102.957"></polyline>
 <polyline points="69.2066,102.957 69.2074,102.928"></polyline>
 <polyline points="69.2074,102.928 69.2077,102.904"></polyline>
 <polyline points="69.2077,102.904 69.2076,102.875"></polyline>
 <polyline points="69.2076,102.875 69.2072,102.851"></polyline>
 <polyline points="69.2072,102.851 69.2061,102.817"></polyline>
 <polyline points="69.2061,102.817 69.2046,102.784"></polyline>
 <polyline points="69.2046,102.784 69.2029,102.757"></polyline>
 <polyline points="69.2029,102.757 69.1996,102.714"></polyline>
 <polyline points="69.1996,102.714 69.1962,102.676"></polyline>
 <polyline points="69.1962,102.676 69.1927,102.644"></polyline>
 <polyline points="69.1927,102.644 69.1884,102.607"></polyline>
 <polyline points="69.1884,102.607 69.1838,102.572"></polyline>
 <polyline points="69.1838,102.572 69.1799,102.545"></polyline>
 <polyline points="69.1799,102.545 69.1722,102.495"></polyline>
 <polyline points="69.1722,102.495 69.1653,102.455"></polyline>
 <polyline points="69.1653,102.455 69.1577,102.414"></polyline>
 <polyline points="69.1577,102.414 69.1485,102.368"></polyline>
 <polyline points="69.1485,102.368 69.1388,102.322"></polyline>
 <polyline points="69.1388,102.322 69.1321,102.292"></polyline>
 <polyline points="69.1321,102.292 69.123,102.254"></polyline>
 <polyline points="69.123,102.254 69.1131,102.214"></polyline>
 <polyline points="69.1131,102.214 69.1032,102.176"></polyline>
 <polyline points="69.1032,102.176 69.0923,102.136"></polyline>
 <polyline points="69.0923,102.136 69.0855,102.112"></polyline>
 <polyline points="69.0855,102.112 69.0751,102.076"></polyline>
 <polyline points="69.0751,102.076 69.0606,102.029"></polyline>
 <polyline points="69.0606,102.029 69.053,102.005"></polyline>
 <polyline points="69.053,102.005 69.0408,101.968"></polyline>
 <polyline points="69.0408,101.968 69.0306,101.938"></polyline>
 <polyline points="69.0306,101.938 69.0116,101.884"></polyline>
 <polyline points="69.0116,101.884 68.9931,101.835"></polyline>
 <polyline points="68.9931,101.835 68.9743,101.787"></polyline>
 <polyline points="68.9743,101.787 68.9584,101.748"></polyline>
 <polyline points="68.9584,101.748 68.9363,101.696"></polyline>
 <polyline points="68.9363,101.696 68.9229,101.666"></polyline>
 <polyline points="68.9229,101.666 68.8998,101.616"></polyline>
 <polyline points="68.8998,101.616 68.8784,101.572"></polyline>
 <polyline points="68.8784,101.572 68.8569,101.53"></polyline>
 <polyline points="68.8569,101.53 68.8338,101.486"></polyline>
 <polyline points="68.8338,101.486 68.8052,101.435"></polyline>
 <polyline points="68.8052,101.435 68.7833,101.398"></polyline>
 <polyline points="68.7833,101.398 68.7634,101.366"></polyline>
 <polyline points="68.7634,101.366 68.7414,101.331"></polyline>
 <polyline points="68.7414,101.331 68.7161,101.294"></polyline>
 <polyline points="68.7161,101.294 68.6995,101.27"></polyline>
 <polyline points="68.6995,101.27 68.6874,101.253"></polyline>
 <polyline points="68.6874,101.253 68.6748,101.236"></polyline>
 <polyline points="68.6748,101.236 68.6542,101.209"></polyline>
 <polyline points="68.6542,101.209 68.634,101.184"></polyline>
 <polyline points="68.634,101.184 68.6163,101.163"></polyline>
 <polyline points="68.6163,101.163 68.5969,101.14"></polyline>
 <polyline points="68.5969,101.14 68.5764,101.117"></polyline>
 <polyline points="68.5764,101.117 68.5544,101.094"></polyline>
 <polyline points="68.5544,101.094 68.5363,101.076"></polyline>
 <polyline points="68.5363,101.076 68.5148,101.055"></polyline>
 <polyline points="68.5148,101.055 68.4996,101.041"></polyline>
 <polyline points="68.4996,101.041 68.4866,101.029"></polyline>
 <polyline points="68.2662,104.169 68.2381,104.075 68.2201,104.003 68.2081,103.946 68.1962,103.88 68.1836,103.787 68.176,103.703 68.1733,103.653 68.1717,103.589 68.1724,103.518 68.1742,103.473 68.1762,103.438 68.1798,103.392 68.1838,103.353 68.1886,103.313 68.1937,103.277 68.2016,103.228 68.2122,103.173 68.2257,103.113 68.2392,103.061 68.2577,102.997 68.274,102.948 68.2963,102.887 68.3137,102.843 68.3285,102.809 68.3424,102.778 68.3575,102.747 68.3747,102.713 68.3942,102.676 68.4164,102.638 68.4479,102.587 68.4653,102.56 68.4749,102.546 68.4866,102.529"></polyline>
 <polyline points="68.2662,104.169 68.2385,104.137"></polyline>
 <polyline points="68.2385,104.137 68.2144,104.108"></polyline>
 <polyline points="68.2144,104.108 68.1923,104.08"></polyline>
 <polyline points="68.1923,104.08 68.1697,104.051"></polyline>
 <polyline points="68.1697,104.051 68.146,104.019"></polyline>
 <polyline points="68.146,104.019 68.1317,103.999"></polyline>
 <polyline points="68.1317,103.999 68.1156,103.976"></polyline>
 <polyline points="68.1156,103.976 68.1007,103.954"></polyline>
 <polyline points="68.1007,103.954 68.0859,103.932"></polyline>
 <polyline points="68.0859,103.932 68.0703,103.908"></polyline>
 <polyline points="68.0703,103.908 68.0569,103.887"></polyline>
 <polyline points="68.0569,103.887 68.0418,103.862"></polyline>
 <polyline points="68.0418,103.862 68.0282,103.839"></polyline>
 <polyline points="68.0282,103.839 68.009,103.806"></polyline>
 <polyline points="68.009,103.806 67.998,103.786"></polyline>
 <polyline points="67.998,103.786 67.9829,103.758"></polyline>
 <polyline points="67.9829,103.758 67.9693,103.732"></polyline>
 <polyline points="67.9693,103.732 67.955,103.703"></polyline>
 <polyline points="67.955,103.703 67.9415,103.675"></polyline>
 <polyline points="67.9415,103.675 67.928,103.645"></polyline>
 <polyline points="67.928,103.645 67.9164,103.619"></polyline>
 <polyline points="67.9164,103.619 67.9028,103.586"></polyline>
 <polyline points="67.9028,103.586 67.8948,103.567"></polyline>
 <polyline points="67.8948,103.567 67.8856,103.543"></polyline>
 <polyline points="67.8856,103.543 67.8782,103.523"></polyline>
 <polyline points="67.8782,103.523 67.869,103.498"></polyline>
 <polyline points="67.869,103.498 67.8621,103.478"></polyline>
 <polyline points="67.8621,103.478 67.8524,103.448"></polyline>
 <polyline points="67.8524,103.448 67.8434,103.419"></polyline>
 <polyline points="67.8434,103.419 67.835,103.391"></polyline>
 <polyline points="67.835,103.391 67.8231,103.347"></polyline>
 <polyline points="67.8231,103.347 67.8143,103.311"></polyline>
 <polyline points="67.8143,103.311 67.8055,103.272"></polyline>
 <polyline points="67.8055,103.272 67.7974,103.232"></polyline>
 <polyline points="67.7974,103.232 67.7902,103.192"></polyline>
 <polyline points="67.7902,103.192 67.7826,103.142"></polyline>
 <polyline points="67.7826,103.142 67.7762,103.091"></polyline>
 <polyline points="67.7762,103.091 67.771,103.036"></polyline>
 <polyline points="67.771,103.036 67.7689,103.006"></polyline>
 <polyline points="67.7689,103.006 67.7666,102.957"></polyline>
 <polyline points="67.7666,102.957 67.7658,102.928"></polyline>
 <polyline points="67.7658,102.928 67.7656,102.904"></polyline>
 <polyline points="67.7656,102.904 67.7656,102.875"></polyline>
 <polyline points="67.7656,102.875 67.7661,102.851"></polyline>
 <polyline points="67.7661,102.851 67.7671,102.817"></polyline>
 <polyline points="67.7671,102.817 67.7687,102.784"></polyline>
 <polyline points="67.7687,102.784 67.7703,102.757"></polyline>
 <polyline points="67.7703,102.757 67.7736,102.714"></polyline>
 <polyline points="67.7736,102.714 67.7771,102.676"></polyline>
 <polyline points="67.7771,102.676 67.7805,102.644"></polyline>
 <polyline points="67.7805,102.644 67.7848,102.607"></polyline>
 <polyline points="67.7848,102.607 67.7894,102.572"></polyline>
 <polyline points="67.7894,102.572 67.7933,102.545"></polyline>
 <polyline points="67.7933,102.545 67.8011,102.495"></polyline>
 <polyline points="67.8011,102.495 67.8079,102.455"></polyline>
 <polyline points="67.8079,102.455 67.8156,102.414"></polyline>
 <polyline points="67.8156,102.414 67.8247,102.368"></polyline>
 <polyline points="67.8247,102.368 67.8344,102.322"></polyline>
 <polyline points="67.8344,102.322 67.8411,102.292"></polyline>
 <polyline points="67.8411,102.292 67.8502,102.254"></polyline>
 <polyline points="67.8502,102.254 67.8602,102.214"></polyline>
 <polyline points="67.8602,102.214 67.87,102.176"></polyline>
 <polyline points="67.87,102.176 67.881,102.136"></polyline>
 <polyline points="67.881,102.136 67.8878,102.112"></polyline>
 <polyline points="67.8878,102.112 67.8982,102.076"></polyline>
 <polyline points="67.8982,102.076 67.9126,102.029"></polyline>
 <polyline points="67.9126,102.029 67.9202,102.005"></polyline>
 <polyline points="67.9202,102.005 67.9324,101.968"></polyline>
 <polyline points="67.9324,101.968 67.9427,101.938"></polyline>
 <polyline points="67.9427,101.938 67.9616,101.884"></polyline>
 <polyline points="67.9616,101.884 67.9801,101.835"></polyline>
 <polyline points="67.9801,101.835 67.9989,101.787"></polyline>
 <polyline points="67.9989,101.787 68.0148,101.748"></polyline>
 <polyline points="68.0148,101.748 68.0369,101.696"></polyline>
 <polyline points="68.0369,101.696 68.0504,101.666"></polyline>
 <polyline points="68.0504,101.666 68.0735,101.616"></polyline>
 <polyline points="68.0735,101.616 68.0948,101.572"></polyline>
 <polyline points="68.0948,101.572 68.1163,101.53"></polyline>
 <polyline points="68.1163,101.53 68.1394,101.486"></polyline>
 <polyline points="68.1394,101.486 68.168,101.435"></polyline>
 <polyline points="68.168,101.435 68.19,101.398"></polyline>
 <polyline points="68.19,101.398 68.2098,101.366"></polyline>
 <polyline points="68.2098,101.366 68.2318,101.331"></polyline>
 <polyline points="68.2318,101.331 68.2571,101.294"></polyline>
 <polyline points="68.2571,101.294 68.2737,101.27"></polyline>
 <polyline points="68.2737,101.27 68.2858,101.253"></polyline>
 <polyline points="68.2858,101.253 68.2985,101.236"></polyline>
 <polyline points="68.2985,101.236 68.3191,101.209"></polyline>
 <polyline points="68.3191,101.209 68.3392,101.184"></polyline>
 <polyline points="68.3392,101.184 68.3569,101.163"></polyline>
 <polyline points="68.3569,101.163 68.3763,101.14"></polyline>
 <polyline points="68.3763,101.14 68.3969,101.117"></polyline>
 <polyline points="68.3969,101.117 68.4188,101.094"></polyline>
 <polyline points="68.4188,101.094 68.4369,101.076"></polyline>
 <polyline points="68.4369,101.076 68.4585,101.055"></polyline>
 <polyline points="68.4585,101.055 68.4737,101.041"></polyline>
 <polyline points="68.4737,101.041 68.4866,101.029"></polyline>
</g>
<g stroke-width="0.15" stroke="none" fill="rgb(0,0,0)">
 <path stroke="none" fill="rgb(0,0,0)" d="M65.74,108.093 66.6858,107.62 66.6858,108.566 65.74,108.093z"></path>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="66.6858,107.62 66.6858,108.566"></polyline>
 <polyline points="66.6858,108.566 65.74,108.093"></polyline>
 <polyline points="66.6858,107.62 65.74,108.093"></polyline>
 <polyline points="66.2129,109.039 65.2671,109.039"></polyline>
 <polyline points="65.2671,109.039 65.74,108.093"></polyline>
 <polyline points="66.2129,109.039 65.74,108.093"></polyline>
</g>
<g stroke-width="0.15" stroke="none" fill="rgb(0,0,0)">
 <path stroke="none" fill="rgb(0,0,0)" d="M65.74,108.093 65.2671,109.039 66.2129,109.039 65.74,108.093z"></path>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <polyline points="65.2671,107.147 66.2129,107.147"></polyline>
 <polyline points="66.2129,107.147 65.74,108.093"></polyline>
 <polyline points="65.2671,107.147 65.74,108.093"></polyline>
 <circle cx="71.4151" cy="105.965" r="0.709384"></circle>
 <polyline points="71.4151,105.256 70.7057,105.965"></polyline>
 <polyline points="71.4151,105.256 72.1245,105.965"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(255,0,0)" stroke-linecap="round">
 <polyline points="83.2405,54.4165 83.2405,17.7649"></polyline>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(0,41,165)" stroke-linecap="round">
 <polyline points="92.699,54.4165 92.699,52.9079"></polyline>
 <polyline points="92.699,51.7066 92.699,49.3042"></polyline>
 <polyline points="92.699,48.1029 92.699,45.7005"></polyline>
 <polyline points="92.699,44.4993 92.699,42.0968"></polyline>
 <polyline points="92.699,40.8956 92.699,38.4931"></polyline>
 <polyline points="92.699,37.2919 92.699,34.8895"></polyline>
 <polyline points="92.699,33.6882 92.699,31.2858"></polyline>
 <polyline points="92.699,30.0846 92.699,27.6821"></polyline>
 <polyline points="92.699,26.4809 92.699,24.0784"></polyline>
 <polyline points="92.699,22.8772 92.699,20.4748"></polyline>
 <polyline points="92.699,19.2735 92.699,17.7649"></polyline>
 <polyline points="92.699,17.7649 90.3344,17.7649"></polyline>
</g>
<g stroke-width="0.2" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <circle cx="87.9698" cy="17.7649" r="2.36462"></circle>
 <circle cx="87.9698" cy="17.7649" r="1.89169"></circle>
</g>
<g stroke-width="0.35" fill="none" stroke="rgb(255,0,0)" stroke-linecap="round">
 <polyline points="85.6051,17.7649 83.2405,17.7649"></polyline>
</g>
<g stroke-width="0.05" fill="none" stroke="rgb(0,0,0)" stroke-linecap="round">
 <path d="M87.0239,21.0754 A0.945847,0.945847 0 0,0 87.0239,22.9671"></path>
 <path d="M88.9156,22.9671 A0.945847,0.945847 0 0,0 88.9156,21.0754"></path>
 <polyline points="88.9156,21.0754 87.0239,21.0754"></polyline>
 <polyline points="87.0239,22.9671 88.9156,22.9671"></polyline>
</g>
<g stroke-width="0.05" stroke="none" fill="rgb(0,0,0)">
 <text transform="matrix(1.13502 0 -0 1.13502 86.5154 22.5887)" font-family="Arial,sans-serif" font-size="1.39636">H50</text>
</g>
</svg>`;
